import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { DocumentoService } from "src/app/services/documento.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { RutService } from "src/app/shared/services/rut.service";

@Component({
  selector: 'app-libro-venta',
  templateUrl: './libro-venta.component.html',
  styleUrls: ['./libro-venta.component.scss'],
  providers: [SecurityService]
})
export class LibroVentaComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  optionsTipoDTE: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private documentoService: DocumentoService,
    private tipoDTEService: TipoDTEService,
    private rutService: RutService,
  ) {
    this.log = this.clog.log('REP. VTAS. LIBRO-VENTA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10
    this.loadMonths()
    this.loadYears()
    this.loadComboTipoDTE()
    this.createForm()
    this.setDefaults()
  }

  loadMonths() {
    this.optionsMonth = this.datesService.GetMonths()
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears(10)
  }

  setDefaults() {
    if (this.optionsMonth.length > 0)
      this.formHeader.get('mes').setValue((new Date().getMonth() + 1))
    if (this.optionsYear.length > 0)
      this.formHeader.get('anho').setValue(this.optionsYear[0].value)
  }

  private createForm() {
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      mes: [null],
      anho: [null],
      listaTipoDTE: [null]
    });
  }

  private loadComboTipoDTE() {
    // Tipos documentos
    this.tipoDTEService.GetByTipoDte(3, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsTipoDTE = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
      //this.setDefaultDoctoReferencia()
    })
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber)
    this.detalleBuscar(pageNumber)
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/

  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.resumen_paginationContext.CurrentPage = pageNumber

    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null

    const { anho, mes, listaTipoDTE } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        anno: anho,
        mes: mes,
        listaTipoDocumento: listaTipoDTE,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.documentoService.obtenerLibroVentaResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.resumen_listaMovimientosAll = registros
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1
      this.resumen_loading = false

      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.iniciaTotalesResumen()
      this.ObtenerTotalesResumen(this.resumen_listaMovimientosAll)
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  iniciaTotalesResumen() {
    this.resumen_totales = {
      cantidad_documento: 0,
      monto_afecto: 0,
      monto_exento: 0,
      impto_adic: 0,
      monto_iva: 0,
      monto_total: 0
    }
  }

  resumenOnPageChange(context: PaginationContext) {
    this.showPageResumen(context.RequestedPage)
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoService.obtenerLibroVentaResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  ObtenerTotalesResumen(data) {
    this.FetchObtenerTotalesResumen(data, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.resumen_totales = respuesta
    })
  }

  //Obtener totales de documento
  FetchObtenerTotalesResumen(data, callback: Function) {
    const inputParams = {
      lista: this.cleanDetalledocumentoResumen(data),
    }
    this.documentoService.ObtenerTotalesLibroVenta(inputParams, callback)
  }

  private cleanDetalledocumentoResumen(detalleDocumento) {
    // let _detalledocumento = [...detalleDocumento]
    // let _detalledocumento = [];
    // detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    let _detalledocumento = _.cloneDeep(detalleDocumento)
    _detalledocumento.forEach(p => {
      delete p.__typename
    })
    return _detalledocumento
  }
  /********* RESUMEN *********/

  /********* DETALLE *********/
  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.detalle_paginationContext.CurrentPage = pageNumber

    const { anho, mes, listaTipoDTE } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        anno: anho,
        mes: mes,
        listaTipoDocumento: listaTipoDTE,
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.detalle_paginationContext.RecordsByPage
    }
    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.detalle_loading = true
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null

    this.documentoService.obtenerLibroVentaDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1
      this.detalle_listaMovimientosAll.forEach(mov => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })

      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.iniciaTotalesDetalles()
      this.ObtenerTotalesDetalle(this.detalle_listaMovimientosAll)
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  iniciaTotalesDetalles() {
    this.detalle_totales = {
      cantidad_documento: 0,
      monto_afecto: 0,
      monto_exento: 0,
      impto_adic: 0,
      monto_iva: 0,
      monto_total: 0
    }
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage)
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoService.obtenerLibroVentaDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  ObtenerTotalesDetalle(data) {
    this.FetchObtenerTotalesDetalle(data, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.detalle_totales = respuesta
    })
  }

  //Obtener totales de documento
  FetchObtenerTotalesDetalle(data, callback: Function) {
    //this.log('FetchObtenerTotales this.dataCabecera', this.dataCabecera)
    const inputParams = {
      lista: this.cleanDetalledocumentoDetalle(data),
    }
    this.documentoService.ObtenerTotalesLibroVenta(inputParams, callback)
  }

  private cleanDetalledocumentoDetalle(detalleDocumento) {
    // let _detalledocumento = [...detalleDocumento]
    // let _detalledocumento = [];
    // detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    let _detalledocumento = _.cloneDeep(detalleDocumento)
    _detalledocumento.forEach(p => {
      delete p.__typename
      delete p.es_casa_matriz
      delete p.rutFormato
    })
    return _detalledocumento
  }
  /********* DETALLE *********/
}
